import * as TYPES from '../action-types';


export default function Language(state = {
    local:"zh"
}, action) {
    switch(action.type) {
        case TYPES.CHANGE_LANGUAGE://引入的是type里的type值
            if(state.local==="en"){
                state = {...state, local: "zh"};
            }else{
                state = {...state, local: "en"};
            }
            //记录到浏览器
            window.localStorage.setItem("local_lange",state.local);

            break;
            default :
            // state={...state,local:'en'}
             break;
    }
    return state;

}


// WEBPACK FOOTER //
// ./src/store/reducers/Language.js